import ActionTypes from "../../../constants/ActionTypes";
import { IProduct } from "../../../entities/product/types";
import {
  ICompareProductChangeAction, ICompareProductSwitchAction,
  IDeselectAllCompareProductsAction, INormalizeCompareProductsAction,
  IRemoveProductForCompare,
  ISetProductForCompare, IToggleCompareDashboardAction, IToggleCompareShowDiffsAction,
  IFetchProductAction
} from "./types";

export const setProductForCompare = (product: IProduct, productType: string): ISetProductForCompare => ({
  type: ActionTypes.COMPARE.SET_PRODUCT,
  payload: {
    selectedProducts: product,
    productType: productType
  }
});

export const removeProductForCompare = (product: IProduct): IRemoveProductForCompare => ({
  type: ActionTypes.COMPARE.REMOVE_PRODUCT,
  payload: product
});

export const compareProductChangeAction = (status: boolean, productId: number, productType?: string): ICompareProductChangeAction => ({
  type: ActionTypes.COMPARE.CHANGE_PRODUCT,
  payload: {
    productId: productId,
    status: status,
    productType: productType
  }
});

export const deselectAllCompareProductsAction = (): IDeselectAllCompareProductsAction => ({
  type: ActionTypes.COMPARE.DESELECT_ALL
});

export const toggleCompareDashboardAction = (status: boolean): IToggleCompareDashboardAction => ({
  type: ActionTypes.COMPARE.TOGGLE_COMPARE_DASHBOARD,
  payload: status
});

export const toggleCompareShowDiffsAction = (status: boolean): IToggleCompareShowDiffsAction => ({
  type: ActionTypes.COMPARE.TOGGLE_COMPARE_SHOW_DIFFS,
  payload: status
});

export const normalizeCompareProductsAction = (): INormalizeCompareProductsAction => ({
  type: ActionTypes.COMPARE.NORMALIZE_COMPARE_PRODUCTS,
});

export const compareProductSwitchAction = (productId: number, orderNumber: number): ICompareProductSwitchAction => ({
  type: ActionTypes.COMPARE.COMPARE_PRODUCT_SWITCH,
  payload: {
    productId: productId,
    orderNumber: orderNumber
  }
});

export function requestFetchProductForCompare(params: object): IFetchProductAction {
  return {
    type: ActionTypes.COMPARE.FETCH,
    params,
  };
}

export function setProductDataForCompare(data: object): any {
  return {
    type: ActionTypes.COMPARE.SET_COMPARE_DATA,
    payload: data,
  };
}
